// import { createPinia } from 'pinia'

export { useDesignStore } from './modules/designStore/designStore'

export { useUserStore } from './modules/user/index'

export { useRouterTravelStore } from './modules/commonStore/routerTravelStore'

export { useAppRouter } from './router'
